<template>
    <div>
        <div class="item">
            <ui5-checkbox
                :checked="clickToEditOrderLineOverview"
                @change="
                    clickToEditOrderLineOverview = $event.target.checked
                "></ui5-checkbox>
            <div>
                {{ trans('pages.app_settings.click_to_edit') }}
                <router-link to="/orderlineoverview">
                    {{ trans('pages.app_settings.order_line_overview') }}
                </router-link>
            </div>
        </div>

        <!-- Language selector: only show if 2 or more languages available -->
        <div v-if="availableLocales.length >= 2" class="item language-selector">
            <label>{{ trans('pages.app_settings.language') }}</label>

            <!-- Toggle switch for exactly 2 languages -->
            <div v-if="availableLocales.length === 2" class="language-toggle">
                <ui5-switch
                    :checked="selectedLocale === availableLocales[1]"
                    @change="onToggleChange"
                    :disabled="isChangingLocale">
                </ui5-switch>
                <span class="toggle-labels">
                    {{ trans(`pages.app_settings.${availableLocales[0]}`) }} /
                    {{ trans(`pages.app_settings.${availableLocales[1]}`) }}
                </span>
            </div>

            <!-- Dropdown for 3+ languages -->
            <ui5-select
                v-else
                :key="selectedLocale"
                :value="selectedLocale"
                @change="onSelectChange"
                :disabled="isChangingLocale">
                <ui5-option
                    v-for="locale in availableLocales"
                    :key="locale"
                    :value="locale"
                    :selected="selectedLocale === locale">
                    {{ trans(`pages.app_settings.${locale}`) }}
                </ui5-option>
            </ui5-select>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { mapSimpleVuexProperty } from '../helpers/VuexHelper';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            isChangingLocale: false,
        };
    },
    computed: {
        ...mapSimpleVuexProperty('clickToEditOrderLineOverview'),
        ...mapGetters('localization', {
            selectedLocale: 'getCurrentLocale',
            availableLocales: 'getAvailableLocales',
        }),
    },
    async mounted() {
        await this.$store.dispatch('localization/fetchAvailableLocales');
    },
    methods: {
        async changeLanguage(newLocale) {
            if (newLocale === this.selectedLocale) {
                return;
            }

            this.isChangingLocale = true;

            try {
                await this.$store.dispatch('localization/changeLocale', newLocale);
            } catch (error) {
                console.error('Failed to change language:', error);
                alert(this.trans('pages.app_settings.language_change_failed'));
            } finally {
                this.isChangingLocale = false;
            }
        },
        async onToggleChange(event) {
            // For toggle: if checked, use second language, otherwise first
            const newLocale = event.target.checked
                ? this.availableLocales[1]
                : this.availableLocales[0];
            await this.changeLanguage(newLocale);
        },
        async onSelectChange(event) {
            const newLocale = event.detail.selectedOption.value;
            await this.changeLanguage(newLocale);
        },
    },
};
</script>
<style lang="scss" scoped>
.item {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    &.language-selector {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;

        label {
            font-weight: 500;
        }

        ui5-select {
            min-width: 200px;
        }

        .language-toggle {
            display: flex;
            align-items: center;
            gap: 0.75rem;

            .toggle-labels {
                font-size: 0.875rem;
                color: #333;
            }
        }
    }
}
</style>
